import React from 'react';
import { TrendingUp, TrendingDown, Minus } from 'lucide-react';

interface MetricCardProps {
  title: string;
  value: number | string;
  subtitle?: string;
  trend?: 'up' | 'down' | 'stable';
  trendValue?: string;
  icon?: React.ReactNode;
  color?: 'primary' | 'sage' | 'amber' | 'coral';
}

export const MetricCard: React.FC<MetricCardProps> = ({
  title,
  value,
  subtitle,
  trend,
  trendValue,
  icon,
  color = 'primary',
}) => {
  const colorClasses = {
    primary: 'bg-primary-50 border-primary-200 text-primary-700',
    sage: 'bg-sage-50 border-sage-200 text-sage-700',
    amber: 'bg-[var(--mustard-dim)] border-[var(--mustard)] text-[var(--mustard)]',
    coral: 'bg-coral-50 border-coral-200 text-coral-700',
  };

  const getTrendIcon = () => {
    if (trend === 'up') return <TrendingUp className="h-4 w-4 text-sage-600" />;
    if (trend === 'down') return <TrendingDown className="h-4 w-4 text-coral-600" />;
    return <Minus className="h-4 w-4 text-charcoal-400" />;
  };

  return (
    <div className={` border p-6 ${colorClasses[color]}`}>
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <p className="text-sm font-medium text-charcoal-600">{title}</p>
          <p className="mt-2 text-3xl font-bold text-charcoal-900">{value}</p>
          {subtitle && (
            <p className="mt-1 text-xs text-charcoal-600">{subtitle}</p>
          )}
        </div>
        {icon && (
          <div className="ml-4">
            {icon}
          </div>
        )}
      </div>
      
      {(trend || trendValue) && (
        <div className="mt-4 flex items-center gap-2">
          {trend && getTrendIcon()}
          {trendValue && (
            <span className="text-sm text-charcoal-600">{trendValue}</span>
          )}
        </div>
      )}
    </div>
  );
};

